import { gptModelsActionTypes } from '@constants/actionTypes';

const defaultState = {
  status: 'idle',
  models: [],
  defaultId: null,
  error: null,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case gptModelsActionTypes.setLoading: {
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    }

    case gptModelsActionTypes.set: {
      const { models, defaultId } = action.payload || {};
      return {
        ...state,
        status: 'ready',
        models: Array.isArray(models) ? models : [],
        defaultId: defaultId || null,
        error: null,
      };
    }

    case gptModelsActionTypes.setError: {
      const { error } = action.payload || {};
      return {
        ...state,
        status: 'error',
        error: error || 'Unable to load GPT models',
      };
    }

    default:
      return state;
  }
}
